import React, { Component } from "react";
import { Link } from "react-router-dom";
import store from "../../../store";
import { VerifyToken } from "../../../actions/user/login";
import { TO_LOGIN } from "../../../helpers/constants";
import { AuthShell, AuthStatus } from "../auth-shell";

class EmailConfirm extends Component {
  state = { token: this.props.match.params.token, verificationStarted: false, verificationComplete: false, verified: false };

  handleConfirm = () => {
    if (this.state.verificationStarted) return;
    this.setState({ verificationStarted: true });
    store.dispatch(VerifyToken({ data: this.state.token }))
      .then((result) => this.setState({ verificationComplete: true, verified: Boolean(result && result.status) }))
      .catch(() => this.setState({ verificationComplete: true, verified: false }));
  };

  renderContent() {
    if (!this.state.verificationStarted) {
      return <AuthStatus type="info" icon="fa-envelope" title="Confirm your email"><p>Verify your email address to activate your BlueSky account.</p><button className="auth-primary" type="button" onClick={this.handleConfirm}>Confirm email</button></AuthStatus>;
    }

    if (!this.state.verificationComplete) {
      return <AuthStatus type="info" icon="fa-circle-o-notch fa-spin" title="Verifying your email"><p>This should only take a moment.</p></AuthStatus>;
    }

    if (this.state.verified) {
      return <AuthStatus title="Email verified"><p>Your account is active and ready to use.</p><Link className="auth-primary" to={TO_LOGIN}>Continue to sign in</Link></AuthStatus>;
    }

    return <AuthStatus type="error" title="Verification link unavailable"><p>This link is invalid, expired, or has already been used.</p><Link className="auth-secondary" to={TO_LOGIN}>Return to sign in</Link></AuthStatus>;
  }

  render() {
    return <AuthShell eyebrow="Account verification" title="Email verification" compact>{this.renderContent()}</AuthShell>;
  }
}

export default EmailConfirm;
